// extracted by mini-css-extract-plugin
module.exports = {"appointmentType":"AppointmentType_appointmentType__yUMiX","input":"AppointmentType_input__sv5_v"};